// Palette de couleurs pastel réutilisable dans l'application
// Importer les couleurs via : import { pastel } from '../theme/palette';

export const pastel = {
  // boutons / actions
  primaryBg: '#E6DFF7', // mauve pastel (boutons principaux)
  primaryColor: '#2E1A55',

  exportBg: '#E6F2FF',  // bleu pastel (export)
  exportColor: '#003A66',

  printBg: '#FFF4E6',   // orange/pêche pastel (impression)
  printColor: '#7A4300',

  // table / rows
  headerBg: '#FBFBFF',
  rowHover: '#FFF8F2',

  // papers / surfaces
  surfaceLight: '#FCFDFF'
};